import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungMultimediaListStatus: 'idle',
    loadMeldungMultimediaListError: undefined as any,
    loadMeldungMultimediaListLastArgs: undefined as any,
    loadMeldungMultimediaStatus: 'idle',
    loadMeldungMultimediaError: undefined as any,
    saveMeldungMultimediaStatus: 'idle',
    saveMeldungMultimediaError: undefined as any,
    deleteMeldungMultimediaStatus: 'idle',
    deleteMeldungMultimediaError: undefined as any,

    meldungMultimediaList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungMultimediaList = createAsyncThunk('meldungMultimediaSlice/loadMeldungMultimediaList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungMultimediaSlice.loadMeldungMultimediaListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremmultimedia/?action=gte&MIN_MODULTYPE=2&MAX_MODULTYPE=2&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungMultimediaListStatus } = getState().meldungMultimediaSlice
        return loadMeldungMultimediaListStatus !== 'pending'
    }
})

export const loadMeldungMultimedia = createAsyncThunk('meldungMultimediaSlice/loadMeldungMultimedia', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ncremmultimedia/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungMultimediaStatus } = getState().meldungMultimediaSlice
        return loadMeldungMultimediaStatus !== 'pending'
    }
})

export const saveMeldungMultimedia = createAsyncThunk('meldungMultimediaSlice/saveMeldungMultimedia', async ({ meldungMultimedia }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungMultimedia?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremmultimedia/${ meldungMultimedia?.HDR_ID }/`,
            prepareData(meldungMultimedia),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremmultimedia/`,
            prepareData(meldungMultimedia),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungMultimediaStatus } = getState().meldungMultimediaSlice
        return saveMeldungMultimediaStatus !== 'pending'
    }
})

export const deleteMeldungMultimedia = createAsyncThunk('meldungMultimediaSlice/deleteMeldungMultimedia', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremmultimedia/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungMultimediaStatus } = getState().meldungMultimediaSlice
        return deleteMeldungMultimediaStatus !== 'pending'
    }
})

const MeldungMultimediaSlice = createSlice({
    name: 'meldungMultimediaSlice',
    initialState,
    reducers: {
        resetloadMeldungMultimediaListError: (state) => {
            state.loadMeldungMultimediaListError = undefined
        },
        resetloadMeldungMultimedia: (state) => {
            state.formItem = undefined
            state.loadMeldungMultimediaError = undefined
        },
        resetloadMeldungMultimediaError: (state) => {
            state.loadMeldungMultimediaError = undefined
        },
        resetsaveMeldungMultimedia: (state) => {
            state.formItem = undefined
            state.saveMeldungMultimediaError = undefined
        },
        resetsaveMeldungMultimediaError: (state) => {
            state.saveMeldungMultimediaError = undefined
        },
        resetdeleteMeldungMultimediaError: (state) => {
            state.deleteMeldungMultimediaError = undefined
        },
        removeFromMeldungMultimediaListById: (state, action) => {
            state.meldungMultimediaList = state.meldungMultimediaList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungMultimediaListByIds: (state, action) => {
            state.meldungMultimediaList = state.meldungMultimediaList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungMultimediaList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungMultimediaListStatus = 'preloaded'
            state.loadMeldungMultimediaListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungMultimediaList = []
            state.loadMeldungMultimediaListStatus = 'idle'
            state.loadMeldungMultimediaListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungMultimediaList.pending, (state) => {
            state.loadMeldungMultimediaListStatus = 'pending'
            state.loadMeldungMultimediaListError = undefined
        })
        builder.addCase(loadMeldungMultimediaList.fulfilled, (state, action) => {
            state.loadMeldungMultimediaListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungMultimediaListLastArgs = action.payload.args

            {
                state.meldungMultimediaList = action.payload.data

            }
        })
        builder.addCase(loadMeldungMultimediaList.rejected, (state, action) => {
            state.loadMeldungMultimediaListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungMultimediaListError = action.error.message
            } else {
                state.loadMeldungMultimediaListError = action.payload
            }
        })

        builder.addCase(loadMeldungMultimedia.pending, (state) => {
            state.loadMeldungMultimediaStatus = 'pending'
            state.loadMeldungMultimediaError = undefined
        })
        builder.addCase(loadMeldungMultimedia.fulfilled, (state, action) => {
            state.loadMeldungMultimediaStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungMultimediaList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungMultimediaList.push(newItem) }
                else { state.meldungMultimediaList[i] = { ...state.meldungMultimediaList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungMultimedia.rejected, (state, action) => {
            state.loadMeldungMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungMultimediaError = action.error.message
            } else {
                state.loadMeldungMultimediaError = action.payload
            }
        })

        builder.addCase(saveMeldungMultimedia.pending, (state) => {
            state.saveMeldungMultimediaStatus = 'pending'
            state.saveMeldungMultimediaError = undefined
        })
        builder.addCase(saveMeldungMultimedia.fulfilled, (state, action) => {
            state.saveMeldungMultimediaStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungMultimediaList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungMultimediaList.push(newItem) }
                else { state.meldungMultimediaList[i] = { ...state.meldungMultimediaList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungMultimedia.rejected, (state, action) => {
            state.saveMeldungMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungMultimediaError = action.error.message
            } else {
                state.saveMeldungMultimediaError = action.payload
            }
        })

        builder.addCase(deleteMeldungMultimedia.pending, (state) => {
            state.deleteMeldungMultimediaStatus = 'pending'
            state.deleteMeldungMultimediaError = undefined
        })
        builder.addCase(deleteMeldungMultimedia.fulfilled, (state, action) => {
            state.deleteMeldungMultimediaStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungMultimediaList = state.meldungMultimediaList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungMultimediaList = state.meldungMultimediaList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungMultimedia.rejected, (state, action) => {
            state.deleteMeldungMultimediaStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungMultimediaError = action.error.message
            } else {
                state.deleteMeldungMultimediaError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungMultimediaListError,
    resetloadMeldungMultimedia,
    resetloadMeldungMultimediaError,
    resetsaveMeldungMultimedia,
    resetsaveMeldungMultimediaError,
    resetdeleteMeldungMultimediaError,
    removeFromMeldungMultimediaListById,
    removeFromMeldungMultimediaListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungMultimediaSlice.actions
export default MeldungMultimediaSlice.reducer
